import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "react-jss";
import { Provider } from "react-redux";
import { ErrorBoundary } from "@sentry/react";

import AppLoader from "@/App";
import ErrorPage from "@/pages/ErrorPage/ErrorPage";
import { store } from "@/store";
import { getTheme } from "@/theme";

import "./styles/styles.scss";
import "./styles/fonts.scss";

import "./sentry";
import "./translation";

const rootElement = document.querySelector("#root");

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <StrictMode>
      <HelmetProvider>
        <Provider store={store}>
          <ThemeProvider theme={getTheme()}>
            <ErrorBoundary fallback={(props) => <ErrorPage {...props} />}>
              <AppLoader />
            </ErrorBoundary>
          </ThemeProvider>
        </Provider>
      </HelmetProvider>
    </StrictMode>,
  );
}
